import { render } from "./ActivesSkeleton.vue?vue&type=template&id=c12c516a&scoped=true"
import script from "./ActivesSkeleton.vue?vue&type=script&lang=js"
export * from "./ActivesSkeleton.vue?vue&type=script&lang=js"

import "./ActivesSkeleton.vue?vue&type=style&index=0&id=c12c516a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c12c516a"]])

export default __exports__